import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgFleet = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 40,
	height: 40,
	viewBox: "0 0 40 40",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M20.3652 26.2494C20.5282 26.3668 20.6248 26.5555 20.6248 26.7564V38.4502C20.6248 38.6413 20.5374 38.8219 20.3875 38.9404C20.2377 39.0589 20.0418 39.1024 19.8559 39.0584L14.2059 37.7209C13.9801 37.6675 13.8026 37.4934 13.7446 37.2688L11.7321 29.4688C11.6501 29.1509 11.8281 28.8237 12.1395 28.7198L19.802 26.1636C19.9926 26.1 20.2022 26.1319 20.3652 26.2494ZM13.0882 29.7211L14.8608 36.5914L19.3748 37.66V27.6238L13.0882 29.7211Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M19.6344 26.2494C19.7975 26.1319 20.007 26.1 20.1976 26.1636L27.8601 28.7198C28.1716 28.8237 28.3495 29.1509 28.2675 29.4688L26.255 37.2688C26.1971 37.4934 26.0195 37.6675 25.7938 37.7209L20.1438 39.0584C19.9579 39.1024 19.762 39.0589 19.6121 38.9404C19.4622 38.8219 19.3748 38.6413 19.3748 38.4502V26.7564C19.3748 26.5555 19.4714 26.3668 19.6344 26.2494ZM20.6248 27.6238V37.66L25.1389 36.5914L26.9115 29.7211L20.6248 27.6238Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M21.7311 23.7064C21.7311 23.3613 22.0109 23.0814 22.3561 23.0814H24.5248C24.87 23.0814 25.1498 23.3613 25.1498 23.7064V28.1877C25.1498 28.5329 24.87 28.8127 24.5248 28.8127C24.1796 28.8127 23.8998 28.5329 23.8998 28.1877V24.3314H22.3561C22.0109 24.3314 21.7311 24.0516 21.7311 23.7064Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M14.8436 23.7064C14.8436 23.3613 15.1234 23.0814 15.4686 23.0814H17.6436C17.9888 23.0814 18.2686 23.3613 18.2686 23.7064C18.2686 24.0516 17.9888 24.3314 17.6436 24.3314H16.0936V28.2627C16.0936 28.6079 15.8138 28.8877 15.4686 28.8877C15.1234 28.8877 14.8436 28.6079 14.8436 28.2627V23.7064Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M17.0186 21.5377C17.0186 21.1925 17.2984 20.9127 17.6436 20.9127H22.3561C22.7013 20.9127 22.9811 21.1925 22.9811 21.5377V23.7064C22.9811 24.0516 22.7013 24.3314 22.3561 24.3314C22.0109 24.3314 21.7311 24.0516 21.7311 23.7064V22.1627H18.2686V23.7064C18.2686 24.0516 17.9888 24.3314 17.6436 24.3314C17.2984 24.3314 17.0186 24.0516 17.0186 23.7064V21.5377Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M9.60902 7.19317C9.772 7.31064 9.86858 7.49929 9.86858 7.70019V19.3939C9.86858 19.585 9.78116 19.7656 9.63129 19.8842C9.48141 20.0027 9.28555 20.0462 9.0996 20.0021L3.4496 18.6646C3.22406 18.6112 3.04659 18.4374 2.98851 18.213L0.969763 10.413C0.887436 10.0949 1.06547 9.76742 1.37718 9.66352L9.04593 7.10727C9.23653 7.04374 9.44604 7.0757 9.60902 7.19317ZM2.32611 10.6648L4.10423 17.5351L8.61858 18.6037V8.56734L2.32611 10.6648Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M8.87819 7.19312C9.04121 7.07566 9.25076 7.04373 9.44136 7.10732L17.1039 9.66357C17.4155 9.76753 17.5935 10.095 17.5111 10.413L15.4924 18.213C15.4343 18.4374 15.2569 18.6112 15.0315 18.6646L9.3877 20.0021C9.20174 20.0462 9.00584 20.0027 8.85593 19.8842C8.70602 19.7657 8.61858 19.5851 8.61858 19.3939V7.70019C8.61858 7.49927 8.71518 7.31059 8.87819 7.19312ZM9.86858 8.56756V18.6035L14.3766 17.5352L16.1548 10.6647L9.86858 8.56756Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M10.9686 4.6502C10.9686 4.30502 11.2484 4.0252 11.5936 4.0252H13.7686C14.1138 4.0252 14.3936 4.30502 14.3936 4.6502V9.13145C14.3936 9.47662 14.1138 9.75645 13.7686 9.75645C13.4234 9.75645 13.1436 9.47662 13.1436 9.13145V5.2752H11.5936C11.2484 5.2752 10.9686 4.99537 10.9686 4.6502Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M4.08733 4.6502C4.08733 4.30502 4.36715 4.0252 4.71233 4.0252H6.88733C7.2325 4.0252 7.51233 4.30502 7.51233 4.6502C7.51233 4.99537 7.2325 5.2752 6.88733 5.2752H5.33733V9.20644C5.33733 9.55162 5.0575 9.83144 4.71233 9.83144C4.36715 9.83144 4.08733 9.55162 4.08733 9.20644V4.6502Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M6.26233 2.48145C6.26233 2.13627 6.54215 1.85645 6.88733 1.85645H11.5936C11.9388 1.85645 12.2186 2.13627 12.2186 2.48145V4.6502C12.2186 4.99537 11.9388 5.2752 11.5936 5.2752C11.2484 5.2752 10.9686 4.99537 10.9686 4.6502V3.10645H7.51233V4.6502C7.51233 4.99537 7.2325 5.2752 6.88733 5.2752C6.54215 5.2752 6.26233 4.99537 6.26233 4.6502V2.48145Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M31.1215 7.19312C31.2845 7.31059 31.3811 7.49927 31.3811 7.70019V19.3939C31.3811 19.5851 31.2936 19.7657 31.1437 19.8842C30.9938 20.0027 30.7979 20.0462 30.612 20.0021L24.9682 18.6646C24.7427 18.6112 24.5653 18.4374 24.5073 18.213L22.4885 10.413C22.4062 10.095 22.5842 9.76753 22.8958 9.66357L30.5583 7.10732C30.7489 7.04373 30.9584 7.07566 31.1215 7.19312ZM23.8448 10.6647L25.623 17.5352L30.1311 18.6035V8.56756L23.8448 10.6647Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M30.3906 7.19317C30.5536 7.0757 30.7631 7.04374 30.9537 7.10727L38.6225 9.66352C38.9342 9.76742 39.1122 10.0949 39.0299 10.413L37.0111 18.213C36.9531 18.4374 36.7756 18.6112 36.5501 18.6646L30.9001 20.0021C30.7141 20.0462 30.5182 20.0027 30.3684 19.8842C30.2185 19.7656 30.1311 19.585 30.1311 19.3939V7.70019C30.1311 7.49929 30.2277 7.31064 30.3906 7.19317ZM31.3811 8.56734V18.6037L35.8954 17.5351L37.6735 10.6648L31.3811 8.56734Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M32.4873 4.6502C32.4873 4.30502 32.7671 4.0252 33.1123 4.0252H35.2811C35.6263 4.0252 35.9061 4.30502 35.9061 4.6502V9.13145C35.9061 9.47662 35.6263 9.75645 35.2811 9.75645C34.9359 9.75645 34.6561 9.47662 34.6561 9.13145V5.2752H33.1123C32.7671 5.2752 32.4873 4.99537 32.4873 4.6502Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M25.6061 4.6502C25.6061 4.30502 25.8859 4.0252 26.2311 4.0252H28.4061C28.7513 4.0252 29.0311 4.30502 29.0311 4.6502C29.0311 4.99537 28.7513 5.2752 28.4061 5.2752H26.8561V9.20644C26.8561 9.55162 26.5763 9.83144 26.2311 9.83144C25.8859 9.83144 25.6061 9.55162 25.6061 9.20644V4.6502Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M27.7811 2.48145C27.7811 2.13627 28.0609 1.85645 28.4061 1.85645H33.1123C33.4575 1.85645 33.7373 2.13627 33.7373 2.48145V4.6502C33.7373 4.99537 33.4575 5.2752 33.1123 5.2752C32.7671 5.2752 32.4873 4.99537 32.4873 4.6502V3.10645H29.0311V4.6502C29.0311 4.99537 28.7513 5.2752 28.4061 5.2752C28.0609 5.2752 27.7811 4.99537 27.7811 4.6502V2.48145Z",
			fill: "currentColor"
		})
	]
});
export default SvgFleet;
